<template>
    <div>
        <!--Control Component -->
        <b-input-group @click="is_visible = true" v-if="isModal">
            <b-form-input readonly :value="sectionString"></b-form-input>
            <b-input-group-append>
                <b-button v-b-modal.locationSubModal variant="outline-primary">
                    <b-icon icon="arrows-angle-expand"></b-icon>
                </b-button>
            </b-input-group-append>
        </b-input-group>

        <!--Modal Component -->
        <b-modal
            v-if="isModal"
            v-model="is_visible"
            :title="modalTitle"
            hide-footer
            size="lg"
        >
            <portal-target name="locationSectionComp"></portal-target>
        </b-modal>

        <!--Section Component -->
        <portal
            to="locationSectionComp"
            :disabled="!isModal || !is_visible"
            v-show="!isModal"
        >
            <b-card :title="title" title-tag="h6">
                <div v-if="searchMode">
                    <b-row no-gutters>
                        <b-col cols="8">
                            <vue-typeahead-bootstrap
                                v-model="searchedName"
                                :data="locations"
                                :serializer="
                                    s =>
                                        s.address1 +
                                        ', ' +
                                        s.address2 +
                                        ', ' +
                                        s.city
                                "
                                @hit="setLocation"
                                @input="lookupLocations"
                                placeholder="Search Existing Locations..."
                            />
                        </b-col>
                        <b-col>
                            <b-button
                                block
                                variant="outline-primary"
                                @click="setCreateLocationMode"
                                >Create Location</b-button
                            >
                        </b-col>
                    </b-row>
                </div>

                <location-view
                    v-if="!searchMode"
                    :id="location_id"
                    :section-only="true"
                    :hide-controls="true"
                    :loading="loading"
                    @cancel="$emit('cancel')"
                    @update-location-model="locationViewModel = $event"
                >
                    <template #default>
                        <b-button
                            v-if="!hideControls && !disabled"
                            class="mr-2"
                            variant="secondary"
                            @click="setSearchMode"
                            >Change Location</b-button
                        >
                        <b-button
                            v-if="!hideControls && !disabled"
                            class="mr-2"
                            variant="primary"
                            @click="$emit('trigger-location-save')"
                            >{{ saveLabel }}</b-button
                        >
                        <slot></slot>
                    </template>
                    <template #section>
                        <b-input-group>
                            <template #prepend>
                                <b-input-group-text
                                    >Section Name:</b-input-group-text
                                >
                            </template>
                            <b-form-input
                                class="pl-2"
                                v-model="currentSection.name"
                                :readonly="disabled"
                                placeholder="Enter or Select The Section Name..."
                            ></b-form-input>

                            <template #append>
                                <b-dropdown
                                    right
                                    variant="success"
                                    v-show="!disabled"
                                >
                                    <b-dropdown-item
                                        v-for="section in sections"
                                        @click="currentSection = section"
                                        :key="'section:' + section.id"
                                        >{{ section.name }}</b-dropdown-item
                                    >
                                </b-dropdown>
                            </template>
                        </b-input-group>
                    </template>
                </location-view>
            </b-card>
        </portal>
    </div>
</template>

<script>
import VueTypeaheadBootstrap from '@/components/VueTypeAhead/VueTypeaheadBootstrap'

import { debounce } from 'lodash'
import LocationView from './LocationView'

import popupMixins from '@/mixins/popupMixins'

export default {
    name: 'LocationSection',
    components: { LocationView, VueTypeaheadBootstrap },
    mixins: [popupMixins],
    data() {
        return {
            currentSection: { name: '', location: {} },
            selectedName: '',
            searchMode: false,
            searchedName: '',
            locationViewModel: null,
            is_visible: false,
            sectionString: '',
        }
    },
    model: {
        prop: 'section_value',
        event: 'change-section-value',
    },
    props: [
        'section_value',
        'hideControls',
        'title',
        'disabled',
        'loading',
        'saveLabel',
        'modalTitle',
        'isModal',
        'searchModeCounter',
        'modalModeCounter',
    ],
    computed: {
        sections() {
            return this.$store.getters['locations/sections']
        },

        simpleLocation() {
            return this.$store.getters['locations/simpleLocation']
        },

        locations() {
            const locations = this.$store.state.locations.locations
            console.log('locations', locations)
            return locations
        },
        location_id() {
            return (
                this.currentSection &&
                this.currentSection.location &&
                this.currentSection.location.id
            )
        },
    },
    watch: {
        searchModeCounter: function () {
            this.setSearchMode()
        },
        modalModeCounter: function () {
            this.is_visible = false
        },
        location_id: function (val) {
            console.log('watch location_id', val)
        },
        'currentSection.id': function (id) {
            this.$emit('change-section-value', id)
        },
        'currentSection.name': debounce(function (_name, _) {
            if (!_) return
            const validSection = this.sections.find(x => x.name === _name)

            console.log('watch section', _name)
            console.log('watch section--validSection', validSection)

            if (validSection) {
                this.currentSection = { ...validSection }
            } else {
                this.currentSection.id = null
            }
        }, 500),

        currentSection: {
            handler: function (val) {
                let location = { ...(this.locationViewModel || {}) }
                const section = { ...val }
                if (section.location && section.location.id && !!location.id)
                    location = section.location

                this.calcSectionString({ section, location })
                this.$emit('update-section-model', { section, location })
            },
            deep: true,
        },

        locationViewModel: {
            handler: function (val) {
                let location = { ...(val || {}) }
                const section = { ...this.currentSection }
                if (section.location && section.location.id && !!location.id)
                    location = section.location
                this.calcSectionString({ section, location })
                this.$emit('update-section-model', { section, location })
            },
            deep: true,
        },

        selectedName: function (nm) {
            console.log('selectedName', nm)
        },
        section_value: function (val) {
            console.log('watching')
            this.setSection(val)
        },
    },
    created() {
        this.$store.dispatch('locations/fetchWarehouses')
    },
    mounted() {
        console.log('locationSection---mounting')
        this.setSection(this.section_value)
    },
    methods: {
        calcSectionString({ section, location }) {
            const section_name = section.name
            location = location || {}
            this.sectionString =
                !location.address1 && !location.address2
                    ? 'Click to Select Location'
                    : (section_name || '') +
                      ',' +
                      (location.address1 || '') +
                      ', ' +
                      (location.address2 || '')
        },
        lookupLocations: debounce(function () {
            // in practice this action should be debounced
            const query = this.searchedName
            const page = 1
            this.$store.dispatch('locations/fetchLocations', {
                query,
                page,
            })
        }, 500),

        setSearchMode() {
            this.searchedName = ''
            this.currentSection = { name: '', location: {} }
            this.searchMode = true
        },
        setCreateLocationMode() {
            this.currentSection = { name: '', location: {} }
            this.searchMode = false
        },

        setLocation(location) {
            console.log('location', location)
            this.currentSection = this.currentSection || { name: '' }
            this.currentSection.location = { ...location }
            this.searchMode = false
        },

        async setSection(id) {
            console.log('setSection----id', id)
            if (id) {
                await this.$store.dispatch('locations/getSection', id)
                await this.$nextTick()
                this.currentSection = { ...this.$store.state.locations.section }
                this.searchMode = false
            }
        },
    },
}
</script>
